'use client';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[Route Error]', error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-5 p-8">
      <div className="w-14 h-14 rounded-full bg-red-500/10 flex items-center justify-center">
        <span className="text-red-400 text-2xl">⚠</span>
      </div>
      <h2 className="text-lg font-semibold text-white/90">Terjadi Kesalahan</h2>
      <p className="text-sm text-white/40 text-center max-w-md">
        {error.message || 'Halaman ini mengalami error. Silakan coba lagi.'}
      </p>
      <button
        onClick={reset}
        className="px-5 py-2.5 text-sm rounded-[var(--radius)] bg-white text-black font-medium hover:bg-white/90 transition-colors"
      >
        Coba Lagi
      </button>
    </div>
  );
}
